import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c4b93a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "widget-casemanager p-7" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = {
  class: "col-lg-3 p-2",
  style: {}
}
const _hoisted_5 = {
  class: "d-flex align-items-center float-start",
  style: {}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "widget-casemanager-content col-lg-7 mt-5" }
const _hoisted_8 = { class: "fw-bolder fs-4 mb-1" }
const _hoisted_9 = { class: "text-gray-400" }
const _hoisted_10 = { class: "col-lg-12 mt-5 float-start" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-phone fs-4" }, null, -1))
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar fs-4" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MBloader = _resolveComponent("MBloader")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_MBloader, { MedicalRecordsTableLoaded: _ctx.isLoaded }, null, 8, ["MedicalRecordsTableLoaded"]),
      (_ctx.isLoaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t("Your Patient Relations Coordinator")), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: _ctx.patient_values.patient_advocate_image,
                  style: {"border-radius":"50%","padding":"3px","box-shadow":"0 0 0 7px #fff, 0 0 0 8px #ddd","width":"90px","height":"auto"}
                }, null, 8, _hoisted_6)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.patient_values.patient_advocate_name), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(_ctx.patient_values.patient_advocate_title)), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("a", {
                href: `tel:${_ctx.$t('MassiveBioPhoneNumber')}`,
                class: "btn btn-secondary btn-sm fw-normal text-dark mb-2"
              }, [
                _hoisted_12,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("Call Now")), 1)
              ], 8, _hoisted_11),
              _createElementVNode("a", {
                href: _ctx.patient_values.schedule_link,
                target: "_blank",
                class: "btn btn-secondary btn-sm fw-normal text-dark mb-2"
              }, [
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("Schedule a Call")), 1)
              ], 8, _hoisted_13)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}